import { TermResponseSubmissionDto } from '@act/shared/data-transfer-objects';
import { Box, Typography } from '@mui/material';
import { DateTime } from 'luxon';
import { userAppSelectors } from 'redux/slices/usersSlice';
import './ConsentHistoryEntry.scss';

export interface ConsentHistoryEntryProps {
  consented: boolean;
  termResponseSubmission: TermResponseSubmissionDto;
}

const ConsentHistoryEntry = ({
  consented,
  termResponseSubmission,
}: ConsentHistoryEntryProps) => {
  const users = userAppSelectors.useSelectUsersMap();

  const termAcceptedByMember = !!termResponseSubmission.consentLinkId;
  const user = users[termResponseSubmission.internalSubmitterUserId];

  let message: string;
  if (termResponseSubmission.ipAddress === 'SMS') {
    message = 'Rejected by member via SMS response';
  } else {
    const userName = user ? `${user?.name}` : 'Unknown user';
    const status = consented ? 'Accepted' : 'Rejected';

    const acceptedBy = termAcceptedByMember
      ? 'by member in web form'
      : `by ${userName} in app`;
    message = `${status} ${acceptedBy}`;
  }

  if (!termResponseSubmission) {
    message = 'No record found for response submission';
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
      <Typography variant="bodyMedium" className="date">
        {DateTime.fromMillis(termResponseSubmission.createdAt).toFormat(
          'MM/dd/yyyy'
        )}
      </Typography>
      <Typography variant="bodyMedium">
        {termAcceptedByMember && termResponseSubmission.languageCode && (
          <div className="language-code">
            {termResponseSubmission.languageCode}
          </div>
        )}
        {message}
      </Typography>
    </Box>
  );
};

export default ConsentHistoryEntry;
